import React from 'react';
import "./PublicationSelector.css"
import PublicationEntry from "./PublicationEntry";
import { padCalendar } from "../../util";
//import { Link } from "react-router-dom";

const PublicationSelector = (props) => (
    <React.Fragment>
        <div id={"commission-selector-title-holder"}>
            <div className={"commission-selector-title"}>SAR Publications</div>
            {/* <Link to={"/publications/create"}><button id={"commission-create-commission-button"}>Create Event Study</button></Link> */}
        </div>
        <table className={"commission-selector-table"}>
            <thead>
                <tr className={"commission-selector-headers"}>
                    <th className={"commission-selector-header"} style={{ "float": "left" }}>Title</th>
                    <th className={"commission-selector-header"}>Type</th>
                    <th className={"commission-selector-header"}>Date</th>
                    <th className={"commission-selector-header"}>Download</th>
                </tr>
            </thead>
            <tbody>
                {props.publications&&props.publications.map((publication,index) =>
	
               
                <PublicationEntry
                    className={publication.publicationId===null?"commission-selector-entrynull":"commission-selector-entry"}
                    key={index}
                    publicationTitle={publication.publicationTitle}
                    enabled={publication.enabled}
                    publicationTypeName={publication.publicationTypeName}
                    publicationDate={padCalendar(publication.publicationDate)}
                    publicationFile={publication.publicationFile}
                    publicationFileUrl={publication.publicationFileUrl}
                    
                    onClick={() => publication.publicationId!==null&&props.onPublicationClick(publication, "pdf")}
                />)
                }
            </tbody>
        </table>
    </React.Fragment>
);


export default PublicationSelector;


// WEBPACK FOOTER //
// ./src/publications/components/PublicationSelector.js